import { getCompoundEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import { techInsightsApiRef } from '@backstage-community/plugin-tech-insights-react';
import useAsync from 'react-use/lib/useAsync';
import { groupByStatus } from '../../techInsights/EntityScorecardCard';

/** The entity's check results, grouped and counted for summaries. */
export const useScorecard = () => {
  const { entity } = useEntity();
  const api = useApi(techInsightsApiRef);
  const { value, loading } = useAsync(
    () => api.runChecks(getCompoundEntityRef(entity)),
    [api, entity],
  );
  const grouped = value ? groupByStatus(api, value) : undefined;
  const passing = grouped?.passing.length ?? 0;
  const failing = grouped?.failing.length ?? 0;
  return { loading, grouped, passing, failing, determined: passing + failing };
};

export type Scorecard = ReturnType<typeof useScorecard>;
